import type { SVGProps } from 'react';

const SvgFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#file_svg__a)">
      <path
        fill="currentcolor"
        d="M18.41 7.022 15 3.612c-.38-.38-.88-.59-1.41-.59H8c-1.65 0-3 1.35-3 3v12c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3v-9.59c0-.53-.21-1.04-.59-1.41m-1.41 11c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-12c0-.55.45-1 1-1h3v3c0 1.65 1.35 3 3 3h3zm0-9h-3c-.55 0-1-.45-1-1v-3h.59L17 8.432z"
      />
    </g>
    <defs>
      <clipPath id="file_svg__a">
        <path fill="#fff" d="M5 3.022h14v18H5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFile;
